import Cookies from 'js-cookie'

const TOKEN_KEY = process.env.REACT_APP_ACCESS_TOKEN_KEY

function setInLocalStorage(key, value) {
  localStorage.setItem(key, btoa(JSON.stringify(value)))
}

export const setCookieToken = (tokenValue) => {
  const CookieDate = new Date()
  CookieDate.setFullYear(CookieDate.getFullYear() + 10)
  const cookieValue = btoa(JSON.stringify(tokenValue))
  Cookies.set(TOKEN_KEY, cookieValue, {
    expires: CookieDate,
    path: '/',
  })

  // Fix: for invoices to get the access token
  setInLocalStorage('shpfrnt', tokenValue)
}

export const getCookieToken = () => {
  if (Cookies.get(TOKEN_KEY)) {
    const cookieValue = Cookies.get(TOKEN_KEY)
    const tokenValue = JSON.parse(atob(`${cookieValue}`))
    return tokenValue
  }

  return false
}
